module.exports = __webpack_public_path__ + "static/media/snake.276f71d2.mov";